<script>
import tableMixin from '@/mixins/table'
import api from '@/helpers/api'
import getInitials from '@/helpers/get-initials'

export default {
  name: 'customer.settings.users',
  mixins: [tableMixin],
  props: {
    customer_id: { type: String }
  },
  data () {
    return {
      isLoading: false,
      search: null,
      showForm: false,
      selectedId: null,
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
          class: 'align-middle',
          thStyle: { width: '250px' }
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true,

          class: 'align-middle'
        },
        {
          key: 'role',
          label: 'Role',
          class: 'align-middle',
          thStyle: { width: '100px' }
        },
        {
          key: 'is_active',
          label: 'Active',
          thStyle: { width: '100px' },
          class: 'text-center align-middle'
        },
        {
          key: 'actions',
          label: '',
          sortable: false,
          thStyle: { width: '100px' },
          class: 'text-right align-middle'
        }
      ]
    }
  },
  mounted () {
    this.onRefresh()
  },
  watch: {
    customer_id: 'onRefresh',
    search: 'onRefresh',
    showForm: {
      async handler (v) {
        if (!v) this.onRefresh()
      }
    }
  },
  methods: {
    async onRefresh () {
      this.isLoading = true
      this.selectedId = null
      let { items, total_rows } = await api.users.fetchPage({
        page: 1,
        pageSize: -1,
        orderBy: { created_at: 'asc' },
        filters: [{ customer_id: { _eq: this.customer_id } }]
      })
      this.data = [...items]
      this.totalRows = total_rows
      this.isLoading = false
    },
    onEdit (item) {
      this.selectedId = item.id
      this.showForm = true
    },

    onNewUser () {
      this.selectedId = null
      this.showForm = true
    },
    async onRemove (user) {
      if (user === undefined) return
      try {
        this.isLoading = true
        await api.users.delete({
          id: user.id
        })

        this.isLoading = false
        this.onRefresh()
      } catch (err) {
        console.error(err)
        this.isLoading = false
      }
    }
  },
  computed: {}
}
</script>
<template>
  <g-overlay :show="isLoading">
    <b-card>
      <h4 class="card-title">Users</h4>

      <b-table
        :show-empty="true"
        hover
        :items="data"
        :fields="fields"
        :busy="isLoading"
        head-variant="primary"
        tbody-tr-class="border-bottom px-2"
        borderless
      >
        <template v-slot:cell(is_active)="{ item }">
          <i class="far fa-check-circle text-success" v-if="item.is_active"></i>
          <i class="fas fa-ban text-danger" v-else></i>
        </template>

        <template v-slot:cell(actions)="row">
          <div class="d-flex align-items-center m-0 p-0">
            <b-button
              variant="outline-dark"
              size="sm"
              @click="onEdit(row.item)"
              class="align-self-center mr-1"
            >
              <i class="far fa-edit"></i>
            </b-button>
            <b-button
              variant="outline-danger"
              size="sm"
              @click="onRemove(row.item)"
              class="align-self-center"
            >
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </div>
        </template>
      </b-table>
      <b-btn class="btn-label" variant="primary" v-on:click="onNewUser">
        <i class="bx bx-plus label-icon"></i>New User
      </b-btn>
      <app-user-form-dialog
        :visible.sync="showForm"
        :customerId="customer_id"
        :userId="selectedId"
        ref="user-form"
      />
    </b-card>
  </g-overlay>
</template>
